'use client'

import { AchieveLink } from 'components/AchieveLink'
import { Typography } from 'components/Typography'
import classNames from 'classnames'

function GlossaryPaginationLink({ direction, link }) {
  const isPrevious = direction === 'prev'
  const label = isPrevious ? '← Previous' : 'Next →'

  return (
    <AchieveLink
      href={link.href}
      rel={direction}
      withNextLink
      className={classNames(
        'block flex-1 rounded-md border border-solid border-gray-200 bg-gray-50 p-4 no-underline transition-colors hover:bg-gray-100 mt-0! w-full md:max-w-[240px]',
        isPrevious ? 'text-left' : 'text-right'
      )}
      track={{
        list_name: 'Glossary Pagination',
        click_text: link.title,
        click_id: link.title,
        click_position: isPrevious ? '0' : '1',
        nav_link_section: 'Glossary Pagination',
        track_event: 'page_nav_click',
        event_action: 'link_click',
        event_type: 'link_click',
      }}
    >
      <span
        className={classNames(
          'flex flex-col gap-1 mt-0!',
          isPrevious ? 'items-start' : 'items-end'
        )}
      >
        <Typography
          variant="labelSm"
          content={label}
          component="span"
          className="block uppercase text-neutral-300 mt-0!"
        />
        <Typography
          variant="headingSm"
          content={link.title}
          component="span"
          className="block text-blue-500 mt-0!"
          fontWeight="medium"
        />
      </span>
    </AchieveLink>
  )
}

function GlossaryPagination({ prev, next }) {
  if (!prev && !next) {
    return null
  }

  return (
    <nav aria-label="Glossary term navigation" className="mt-8 border-t border-neutral-150 pt-8">
      <div className="flex flex-col gap-4 md:flex-row md:justify-between">
        {prev ? (
          <GlossaryPaginationLink direction="prev" link={prev} />
        ) : (
          <div className="flex-1" aria-hidden="true" />
        )}
        {next ? (
          <GlossaryPaginationLink direction="next" link={next} />
        ) : (
          <div className="flex-1" aria-hidden="true" />
        )}
      </div>
    </nav>
  )
}

export { GlossaryPagination }
